import * as z from "zod";

/**
 * A Support V2 conversation, encoded as `TopicId` in
 * `@redotech/effect-api-shared` does. Restated as zod because the merchant
 * surfaces that consume it must not pull in Effect; handlers still produce
 * these values through `TopicId` itself.
 */
export const topicIdSchema = z
  .string()
  .regex(/^cnv_[0-9A-Za-z]+$/, "Topic must match cnv_<base62>")
  .brand<"TopicId">();
export type TopicId = z.infer<typeof topicIdSchema>;
